import { useEffect, useState } from 'react';

export function useDirection() {
  const [dir, setDir] = useState<'ltr' | 'rtl'>(
    () => (document.documentElement.dir as 'ltr' | 'rtl') || 'rtl'
  );
  useEffect(() => {
    document.documentElement.dir = 'rtl';
    setDir('rtl');
  }, []);
  return dir;
}
